import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { LogScreen } from "../../screens/settings-money/index.ts";

/** `/settings/guardian/log`: the security log, newest first (see `LogScreen`). */
export const Route = createFileRoute("/_app/settings/guardian_/log")({
  loader: ({ context }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("guardian.readLog", { limit: 50 })),
  component: LogScreen,
});
